import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  width: 100%;\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  ", "\n  &.address-form-country {\n    > div:first-of-type {\n      margin-bottom: 10px;\n    }\n  }\n  & > div {\n    width: calc(50% - 10px / 2);\n    ", "\n  }\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 2rem;\n  background-color: ", ";\n  min-height: 230px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    width: 80%;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 366px;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  line-height: 1em;\n  padding: 16px 25px;\n  font-size: 18px;\n  position: relative;\n  color: ", ";\n  &:first-child {\n    &:before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      background-color: rgba(0, 0, 0, 0.1);\n      width: 1px;\n      height: 32px;\n      top: 50%;\n      right: 0;\n      transform: translateY(-50%);\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    transform: none;\n    left: 0;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  left: 50%;\n  position: relative;\n  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  transform: translate(-50%, 0%);\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    text-align: left;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font: 16px ", ";\n  margin-bottom: 8px;\n  opacity: 0.8;\n  text-align: center;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 30px;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var AddressForm = styled.form(_templateObject());
export var Tabs = styled.div(_templateObject2(), media.extraSmallScreen(_templateObject3()));
export var TabsTitle = styled.div(_templateObject4(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.smallScreen(_templateObject5()));
export var TabsButtonsWrapper = styled.div(_templateObject6(), media.smallScreen(_templateObject7()));
export var TabsButton = styled.button(_templateObject8(), function (props) {
  return props.active ? props.theme.colors.baseFont : props.theme.colors.graySemi;
});
export var Wrapper = styled.div(_templateObject9());
export var DeleteContainer = styled.div(_templateObject10(), media.smallScreen(_templateObject11()));
export var DeleteBody = styled.div(_templateObject12(), function (props) {
  return props.isDefaultBillingAddress && props.isDefaultShippingAddress ? "#F6F7F8" : "#F5F1F2";
});
export var AddressField = styled.div(_templateObject13());
export var RowWithTwoCells = styled.div(_templateObject14(), function (props) {
  return props.margin && "margin-bottom: 0px";
}, media.smallScreen(_templateObject15()), media.xxLargeScreen(_templateObject16(), function (props) {
  return props.margin && "margin-bottom: 0px";
}));
export var RowWithOneCell = styled.div(_templateObject17(), function (props) {
  return props.margin && "margin-bottom: 0px";
}, media.xxLargeScreen(_templateObject18(), function (props) {
  return props.margin && "margin-bottom: 0px";
}));